/**
 * POST /v1/audit/list — body shape aligned with platform API.
 * Tenant / workspace scope is resolved server-side from auth when applicable.
 *
 * @param {number} page
 * @param {number} pageSize
 * @param {string} [searchKeyword] — when non-empty, adds `search: { keyword }` for server-side search
 * @returns {{
 *   page: number,
 *   page_size: number,
 *   order_by: string,
 *   order_direction: string,
 *   search?: { keyword: string },
 * }}
 */
export const buildAuditListBody = (page, pageSize, searchKeyword = '') => {
  const body = {
    page,
    page_size: pageSize,
    order_by: 'created_at',
    order_direction: 'DESC',
  };
  const kw = typeof searchKeyword === 'string' ? searchKeyword.trim() : '';
  if (kw) {
    body.search = { keyword: kw };
  }
  return body;
};
